import { render, staticRenderFns } from "./Human.vue?vue&type=template&id=36adaed1&"
import script from "./Human.vue?vue&type=script&lang=js&"
export * from "./Human.vue?vue&type=script&lang=js&"
import style0 from "./Human.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports